import { getClientId } from 'utils/getClientId'
import { Order } from 'models/Order'
import { useQuery, UseQueryOptions } from 'react-query'
import { ApiClient } from 'services/ApiClient'
import { Api } from 'types/Api'

export namespace FetchNextOrders {
  export type Response = Api.PaginatedResponse<Order, 'orders'>
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = (clientId: string) => ['current-orders', { clientId }]

const queryFetcher = (clientId: string) => () => {
  return ApiClient.get<FetchNextOrders.Response>(`/v1/clients/${clientId}/next-orders`)
}

export const useFetchCurrentOrders = (options?: FetchNextOrders.Options) => {
  const clientId = getClientId() || ''

  return useQuery<FetchNextOrders.Response, FetchNextOrders.Error>(
    createKey(clientId),
    queryFetcher(clientId),
    options
  )
}
